import React from "react";
import { useLocation } from "react-router-dom";
import ChatPage from "../../pages/ChatPage";
import NewChatPage from "../../pages/newChatPage";

export default function LoadChatComponent() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const checkDebug = searchParams.get("debug");

  return (
    <>
      {/* {checkDebug ? (
        <div
          className="chat-iframe"
          dangerouslySetInnerHTML={{
            __html: `<iframe src=${process.env.REACT_APP_IFRAME_BASEURL}/chat/${
              JSON.parse(localStorage.getItem("_user"))["projects"][0]["slug"]
            }?debug=true />`,
          }}
        />
      ) : (
        <div
          className="chat-iframe"
          dangerouslySetInnerHTML={{
            __html: `<iframe src=${process.env.REACT_APP_IFRAME_BASEURL}/chat/${
              JSON.parse(localStorage.getItem("_user"))["projects"][0]["slug"]
            } />`,
          }}
        />
      )} */}
      <ChatPage/>
      {/* <NewChatPage /> */}
    </>
  );
}
